export default {"src":"/_next/static/media/collapse-up.e4774985.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};